import './scss/styles.scss';
import React from 'react';
import handleForms from './components/FormValidation';
import MobileMenu from './components/MobileMenu';
import Header from './components/Header';
import Home from './components/Home';
import Services from './components/Services';
import InquireRentals from './components/InquireRentals';
import AboutUs from './components/AboutUs';
import ContactUs from './components/ContactUs';
import BookNow from './components/BookNow';
import Footer from './components/Footer';

export default function Main() {
  return (
    <div className="Main">
      <MobileMenu />
      <Header />
      <Home />
      <Services />
      <InquireRentals />
      <AboutUs />
      <ContactUs />
      <BookNow />
      <Footer />
    </div>
  )
}

